/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
import prettyNum from 'pretty-num';

export const formatNumber = (n: number) =>
  prettyNum(n, { thousandsSeparator: ',' });
